export const siteKey = 1;
export const secretKey = "caViMEzciS7PyJPYdFPcyIHsLdkeEHhqLs9Y5bgD";

export const domainURL = {
  //BASE: "http://127.0.0.1:3333/",
  // Produksi dengan path API `/service`: BASE harus ada slash akhir, contoh:
   BASE: "https://cctv.devapp.my.id/service/"
};

export const mapTile = {
  URL: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  // URL: "https://maps.tangerangkab.go.id/tiles/styles/basic-preview/{z}/{x}/{y}.png",
  ATTRIBUTION:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
};
